import deliveryCompanies from './deliveryCompanies.json'

// Used: S/Transaction. Array company names without 'other' option
export const DELIVERY_COMPANIES = deliveryCompanies
    .map(({ name }) => name)
    .filter(name => name !== 'Other')
